module.exports = "/packs/step-arrow-c092e22ca1bf9478a0c42f2ae028da9a.png";